import React from 'react'
import {Box} from '@chakra-ui/react'
import Select from '_app/components/Form/StyledSelect'
import {OptionType} from '_app/types/select'
import useSortOptions from '_app/hooks/useSortOptions'
import {useRouter} from '_app/hooks/useRouter'
import URLHelper from '../../helpers/URLHelper/URLHelper'

interface SortProps {
  active: string;
}

const Sort = ({ active }: SortProps) => {
  const router = useRouter()

  const options = useSortOptions().map(option => {
    return { ...option, label: option.label }
  })

  const onChange = ({ value }: OptionType<string>) => {
    const params = URLHelper.getSearchParams()
    if (value) {
      params.order = value
    } else {
      delete params.order
    }
    router.search(params)
  }

  const activeOption = active
    ? options.find(o => o.value == active)
    : options.find(o => o.value == '')
  return (
    <Box minW="210px" zIndex={9}>
      <Select
        instanceId="sort-select"
        options={options}
        onChange={o => onChange(o as OptionType<string>)}
        value={activeOption}
      />
    </Box>
  )
}

export default Sort
